"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RatingPgHandler", {
    enumerable: true,
    get: function() {
        return RatingPgHandler;
    }
});
const _ratinggeneralhandler = require("./rating.general.handler");
const _decimalpghandler = require("~/db/field-handler/handlers/decimal/decimal.pg.handler");
let RatingPgHandler = class RatingPgHandler extends _decimalpghandler.DecimalPgHandler {
    constructor(...args){
        super(...args), this.ratingGeneralHandler = new _ratinggeneralhandler.RatingGeneralHandler(), this.parseUserInput = this.ratingGeneralHandler.parseUserInput, this.filterLt = this.ratingGeneralHandler.filterLt, this.filterLte = this.ratingGeneralHandler.filterLte, this.filterGte = this.ratingGeneralHandler.filterGte;
    }
};
